const fonts = {
  family: '"proxima-nova", Helvetica, Arial, sans-serif',
}

export default fonts
